const hasRole = roles => role => roles.indexOf(role) !== -1;

export default hasRole;
